/* ============
 * waiting to be delivered
 * ============
 *
 */
import { mapGetters } from 'vuex';
import userWidgetsService from './../../../services/widgets';

export default {

    data() {
        return {
            number: 0,
            loaded: false,
        };
    },

    computed: {
        ...mapGetters({
            waitingDeliveredWidgets: 'waitingDeliveredWidgets',
        }),
    },

    watch: {
      waitingDeliveredWidgets(waitingDeliveredWidgets) {
          this.number = waitingDeliveredWidgets.items;
          this.loaded = true;
        },
      },

    methods: {
        initializeWidgets() {
            Promise.all([
              userWidgetsService.fetchWaitingDeliveredWidgets(),
            ]).then(() => {
              this.number = this.waitingDeliveredWidgets.items;
              this.loaded = true;
            });
          },
    },

    created() {
        this.initializeWidgets();
    }

};



// WEBPACK FOOTER //
// ./src/app/components/widgets/waitingDelivered/waitingDelivered.js